/** Marcadores quando o equipamento não envia "resposta comando:" (comum no Orange Pi). */
const UPDATE_OUTPUT_COMPLETE_PATTERNS = [
  /fetch exit:\s*0[\s\S]*Ultima versao:\s*SW\.MT\./i,
  /=== PASSO 1 ===[\s\S]*fetch exit:\s*0[\s\S]*Ultima versao:\s*SW\.MT\./i,
  /\[OK\]\s*sem index\.lock/i,
  /=== PASSO 3 ===[\s\S]*\[OK\]\s*reset\/clean/i,
  /\[OK\]\s*reset\/clean/i,
  /=== PASSO 4 ===[\s\S]*\[OK\]\s*sw-mt atualizado/i,
  /\[OK\]\s*sw-mt atualizado/i,
  /=== PASSO 5 ===[\s\S]*(\[OK\]\s*stable|\[OK\]\s*stable nao existe)/i,
  /\[OK\]\s*stable nao existe, pulando/i,
  /\[OK\]\s*stable/i,
  /\[FALHA\]\s*stable/i,
  /=== PASSO 6 ===[\s\S]*\[OK\]\s*pm2 restart enviado/i,
  /\[OK\]\s*pm2 restart enviado/i,
  /\[OK\]\s*Curvas limpas/i,
  /=== PASSO 9[\s\S]*Versao sw-mt:\s*SW\.MT\./i,
  /\[FALHA\]\s*LATEST vazio/i,
  /\[FALHA\]\s*veja acima/i,
  /=== PROBE SAFE ===[\s\S]*SW\.MT\./i,
];

const hasCommandStream = (output) => /^comando:/m.test(output) || /\ncomando:/.test(output)
  || /Executando comando:\s*process/i.test(output);

export const isCommandResponseComplete = (text) => {
  const output = String(text || '');

  if (/resposta comando:/i.test(output) || /comando:\s*erro/i.test(output)) {
    return true;
  }

  const markerHit = UPDATE_OUTPUT_COMPLETE_PATTERNS.some((re) => re.test(output));
  if (!markerHit) {
    return false;
  }

  if (hasCommandStream(output)) {
    return true;
  }

  return /=== PASSO \d+ ===/i.test(output);
};

export const joinResponseChunks = (chunks) => chunks.filter(Boolean).join('\n');
